import { Sparkles } from 'lucide-react';

import { useAgentPanelContext } from '@/app/agentConversation/_context';
import { cn } from '@/helpers/shadcn';

import { Button } from '@/app/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/app/ui/tooltip';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

/** The rail button that opens and closes the assistant, styled like the rail's links. */
const ToggleAgentPanelButtonForNavigation = () => {
  const panel = useAgentPanelContext();
  if (!panel.isEnabled) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          onClick={panel.toggle}
          aria-label="Assistant"
          data-testid="nav-agent-toggle"
          data-active={panel.isOpen}
          className={cn(
            'text-muted-foreground size-11 rounded-xl',
            panel.isOpen && 'bg-primary/10 dark:bg-secondary/10 text-primary dark:text-secondary hover:bg-primary/10',
            !panel.isOpen && 'hover:bg-accent hover:text-foreground'
          )}
        >
          <Sparkles className="size-5" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="right">Assistant ({isMac ? '⌘' : 'Ctrl+'}J)</TooltipContent>
    </Tooltip>
  );
};

export default ToggleAgentPanelButtonForNavigation;
